import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { AbstractDialogComponent } from '@Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '@Core/Dialogs/services/dialog.service';

import { messageSeverityEnum } from '@Common/Misc/enums/message-severity.enum';
import { ButtonTypesEnum } from '@Common/Forms/enums/button-types.enum';

import { AutoGenerateInsightResponse, BriefingsAutoGenService } from '../../services/briefings-auto-gen.service';


@Component({
    selector: 'agpr-curated-auto-websocket-dialog',
    templateUrl: './curated-auto-websocket-dialog.component.html',
    styleUrls: ['./curated-auto-websocket-dialog.component.scss'],
    standalone: false
})
export class CuratedAutoWebsocketDialogComponent extends AbstractDialogComponent implements OnInit, OnDestroy {

    @Input() briefingId: number;

    isBannerExpanded: boolean = false;

    autoGensStatus: AutoGenerateInsightResponse;

    protected subscriptions: Subscription[] = [];

    readonly buttonTypes = ButtonTypesEnum;
    readonly messageSeverityEnum = messageSeverityEnum;

    constructor(
        public coreDialogService: CoreDialogService,
        private briefingsAutoGenService: BriefingsAutoGenService,
    ) {
        super(coreDialogService, 'CuratedAutoWebsocketDialog');
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.briefingsAutoGenService.getAutoGenStatus().subscribe(autoGensStatus => {
                if (autoGensStatus[this.briefingId]) {
                    this.autoGensStatus = autoGensStatus[this.briefingId];
                }
            })
        );
    }

    @HostListener('window:keyup.escape', ['$event']) onKeyDown(e: KeyboardEvent) {
        if (this.autoGensStatus && !this.autoGensStatus.loading) {
            this.ok();
        }
    }

    isMessageExpanded(event: boolean) {
        this.isBannerExpanded = !event;
    }


    /**
     * Action when the user clicks the "acknowledge" button
     */
    ok(): void {
        this.closeDialog(true);
        this.briefingsAutoGenService.closeAutoGenStatus(this.briefingId);
    }

    /**
     * Action when the user clicks the "hide" button
     */
    hide(): void {
        this.autoGensStatus.showDialog = false;
        this.briefingsAutoGenService.setSpecificAutoGenStatus(this.briefingId, this.autoGensStatus);
        this.closeDialog(false);
        this.ngOnDestroy();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
